import {inject, IReactComponent} from 'mobx-react';
import {RemoteControlPopup} from './RemoteControlPopup';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.remoteControlPopupController,
    translate: stores.localizationService.translate.bind(stores.localizationService)
});

export const RemoteControlPopupComponent = inject(mapStoresToProps)(RemoteControlPopup) as IReactComponent;
